import { useEffect, useState } from "react";
import api from "../../../../../../features/auth/axiosConfig";
import { useUser } from "src/business-types/grocery/components/UserContext";

export interface CustomerData {
  _id: { $oid: string };
  Name: string;
  phone_number: string;
  Email: string;
  Address: string;
  Out_standing_balance?: string;
}

export const useCustomerSearch = (searchTerm: string, pageNumber: number) => {
  const [apiCustomers, setApiCustomers] = useState<CustomerData[]>([]);
  const [localAddedCustomers, setLocalAddedCustomers] = useState<CustomerData[]>([]);
  const [total, setTotal] = useState({ totalRecords: "0", totalPage: "0" });
  const [loading, setLoading] = useState(false);
  const{userConfigration}=useUser()

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setLoading(true);
      const pageSize = userConfigration?.tableDefultSize || 10;
      api
        .get(`/app/v1/pos/customer?include_deleted=False&pageNumber=${pageNumber}&pageSize=${pageSize}&searchBy=${searchTerm}`)
        .then((res) => {
          const data = res.data;
          // merge local added customers at the front
          setApiCustomers([...localAddedCustomers, ...data.customer_details]);
          setTotal({
            totalRecords: String(Number(data.totalRecords)),
            totalPage: String(Math.ceil(Number(data.totalRecords) / pageSize)),
          });
        })
        .catch(console.log)
        .finally(() => setLoading(false));
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, pageNumber, localAddedCustomers, userConfigration]);

  const addCustomerLocally = (customer: CustomerData) => {
    // Add locally
    setLocalAddedCustomers((prev) => [customer, ...prev]);
    // Update total
    setTotal((prev) => ({
      ...prev,
      totalRecords: String(Number(prev.totalRecords) + 1),
    }));
  };

  // Merge API + local customers BEFORE returning
  const customers = [...localAddedCustomers, ...apiCustomers];

  return { customers, total, loading, addCustomerLocally };
};
